import {extractProps} from '@famly/mf_ts-utils_extract-props';

export const extractAriaProps = <P extends Dictionary<string, any>>(props: P) => {
    return extractProps<P, 'aria'>(props, 'aria');
};
